<template>
    <div class="popup-mask">
        <div class="popup-wrapper" :class="[size]">
            <a
                href="javascript:;"
                class="popup-cls"
                @click.prevent="triggerPopCls"
                v-if="hasCls"
            ></a>
            <slot />
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
    name: 'popup-wrapper',
    props: {
        // 是否有关闭按钮
        hasCls: {
            type: Boolean,
            default: true
        },
        // 三种size  big 、mid 、small
        size: {
            type: String,
            default: 'big'
        }
    },
    data() {
        return {};
    },
    methods: {
        ...mapMutations(['PLAY_SOUND', 'STOP_SOUND']),
        triggerPopCls() {
            this.PLAY_SOUND('button');
            this.$emit('pop-cls');
        }
    }
};
</script>

<style lang="less" scoped>
.popup-mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    // border-radius: 28px;
    display: flex;

    .popup-wrapper {
        width: 532px;
        max-height: 780px;
        min-height: 200px;
        margin: auto;
        background: url(~@/assets/img/pop_big_repeat.png) center/100% 100%
            repeat-y;
        position: relative;
        z-index: 1;

        .popup-cls {
            width: 43px;
            height: 43px;
            background: url(~@/assets/img/pop_cls.png) center/100% 100%
                no-repeat;
            position: absolute;
            top: 5px;
            right: 25px;
        }

        &::before {
            content: '';
            width: 532px;
            height: 28px;
            background: url(~@/assets/img/pop_big_top.png) center/100% 100%
                no-repeat;
            position: absolute;
            top: -26px;
            left: 0;
        }

        &::after {
            content: '';
            width: 532px;
            height: 19px;
            background: url(~@/assets/img/pop_big_bottom.png) center/100% 100%
                no-repeat;
            position: absolute;
            bottom: -13px;
            left: 0;
        }

        &.mid {
            width: 441px;
            background: url(~@/assets/img/pop_mid_repeat.png) center/100% 100%
                repeat-y;
            &::before {
                content: '';
                width: 441px;
                height: 26px;
                background: url(~@/assets/img/pop_mid_top.png) center/100% 100%
                    no-repeat;
                position: absolute;
                top: -24px;
                left: 0;
            }
            &::after {
                content: '';
                width: 441px;
                height: 19px;
                background: url(~@/assets/img/pop_mid_bottom.png) center/100%
                    100% no-repeat;
                position: absolute;
                bottom: -17px;
                left: 0;
            }
        }
    }
}
</style>
